/* SUDADEROTAS · Puntada «Tejido 3D»: punto jersey grueso con relieve (dos piernas trenzadas con luz y sombra), como estambre real.
   La puntada se calcula una sola vez (relieve + luz) y se tiñe por color; se usa igual en SVG (símbolos) y en lienzo. */
(function (root) {
"use strict";
var K = root.SDRKit, T = K && K.tej;
if (!T || !T.PUNTOS || T.PUNTOS.k3d) return;
/* variantes: jersey 3D, grueso XL y punto de cruz 3D */
var VAR = { k3d: { bw: .27, f: 2.4, amp: .11, k: 9, sp: .12 }, k3dxl: { bw: .31, f: 1.8, amp: .16, k: 12, sp: .08 }, k3dx: { cruz: true, k: 10, sp: .12 } };
var CW = T.CW, CH = T.CH, W = 96, H = 104, MV = .3, TH = Math.round(H * (1 + MV));
var BASE = {}, TINT = {}, URL = {}, USADOS = null;
function rng(s) { return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
function base(id) {
if (BASE[id]) return BASE[id];
var V = VAR[id];
var n = W * TH, hg = new Float32Array(n), gv = new Float32Array(n), al = new Float32Array(n), r = rng(7), fz = new Float32Array(n), i, x, y;
for (i = 0; i < n; i++) { var a = r(), b = r(); fz[i] = Math.sqrt(-2 * Math.log(a + 1e-9)) * Math.cos(6.2832 * b); }
if (V.cruz) [-1, 1].forEach(function (lado) {
for (y = Math.round(MV * H); y < TH; y++) for (x = 0; x < W; x++) {
var k = y * W + x, X = (x + .5) / W - .5, Y = (y + .5 - MV * H) / H - .5, d = Math.abs(X + lado * Y) / 1.4142, al2 = Math.abs(X - lado * Y) / 1.4142;
var r2 = (d / .17) * (d / .17) + (al2 / .66) * (al2 / .66), h = Math.sqrt(Math.max(0, 1 - r2)) * (.88 + .12 * Math.cos(6.2832 * (al2 * 6 + d * 3))) * (lado > 0 ? 1 : .92);
if (h > hg[k]) { hg[k] = h; gv[k] = 0; }
al[k] = Math.max(al[k], Math.min(1, h / .08));
}
});
else [-1, 1].forEach(function (lado) {
var ax = (.5 + lado * .31) * W, ay = -.2 * H, bx = (.5 + lado * .02) * W, by = .98 * H;
var cx = (ax + bx) / 2, cy = (ay + by) / 2, L = Math.hypot(bx - ax, by - ay), dx = (bx - ax) / L, dy = (by - ay) / L;
for (y = 0; y < TH; y++) for (x = 0; x < W; x++) {
var X = x + .5, Y = y + .5 - MV * H, k = y * W + x;
var s = ((X - cx) * dx + (Y - cy) * dy) / (L / 2), t = -(X - cx) * dy + (Y - cy) * dx;
var sp = Math.max(0, s), sn = Math.max(0, -s), bw = V.bw * W * (1 - .35 * Math.pow(sp, 1.5)) * (1 - .15 * sn * sn), tt = t / bw, r2 = s * s + tt * tt;
var h = Math.sqrt(Math.max(0, 1 - r2)), ph = Math.cos(6.2832 * (s * V.f + lado * tt * .45)), h2 = h * (1 - V.amp - .03 + V.amp * ph + .03 * fz[k]);
if (h2 > hg[k]) { hg[k] = h2; gv[k] = ph; }
al[k] = Math.max(al[k], Math.min(1, Math.max(0, (1 - r2) / .08)));
}
});
var sh = new Float32Array(n), spc = new Float32Array(n), l = [-.45, -.6, .66], ln = Math.hypot(l[0], l[1], l[2]);
l = l.map(function (v) { return v / ln; });
var hv = [l[0], l[1], l[2] + 1], hn = Math.hypot(hv[0], hv[1], hv[2]); hv = hv.map(function (v) { return v / hn; });
for (y = 0; y < TH; y++) for (x = 0; x < W; x++) {
var k2 = y * W + x, xl = x > 0 ? k2 - 1 : k2, xr = x < W - 1 ? k2 + 1 : k2, yu = y > 0 ? k2 - W : k2, yd = y < TH - 1 ? k2 + W : k2;
var gx = (hg[xr] - hg[xl]) * V.k / ((x > 0 && x < W - 1) ? 2 : 1), gy = (hg[yd] - hg[yu]) * V.k / ((y > 0 && y < TH - 1) ? 2 : 1);
var nx = -gx, ny = -gy, nz = 1, nn = Math.hypot(nx, ny, nz); nx /= nn; ny /= nn; nz /= nn;
var dif = Math.max(0, nx * l[0] + ny * l[1] + nz * l[2]), spe = Math.pow(Math.max(0, nx * hv[0] + ny * hv[1] + nz * hv[2]), 8);
sh[k2] = (.45 + .62 * dif) * (.5 + .5 * Math.pow(hg[k2], .5)) * (.93 + .07 * gv[k2]);
spc[k2] = spe * V.sp * 255;
}
return (BASE[id] = { sh: sh, sp: spc, al: al });
}
function rgb(c) {
var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(c).trim());
if (m) { var h = m[1]; if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2]; var v = parseInt(h, 16); return [v >> 16 & 255, v >> 8 & 255, v & 255]; }
m = /rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i.exec(String(c));
return m ? [+m[1], +m[2], +m[3]] : [128, 128, 128];
}
function tenido(id, col) {
var kk = id + col, t = TINT[kk]; if (t) return t;
var B = base(id), c = rgb(col), cv = document.createElement("canvas"); cv.width = W; cv.height = TH;
var x = cv.getContext("2d"), im = x.createImageData(W, TH), d = im.data;
for (var i = 0, n = W * TH; i < n; i++) {
var s = B.sh[i] * 1.05, e = B.sp[i], a = B.al[i], g = i >= W * Math.round(MV * H) ? .26 : -1;
var r0 = Math.min(255, c[0] * s + e), g0 = Math.min(255, c[1] * s + e), b0 = Math.min(255, c[2] * s + e);
if (g > 0) { d[i * 4] = r0 * a + c[0] * g * (1 - a); d[i * 4 + 1] = g0 * a + c[1] * g * (1 - a); d[i * 4 + 2] = b0 * a + c[2] * g * (1 - a); d[i * 4 + 3] = 255; }
else { d[i * 4] = r0; d[i * 4 + 1] = g0; d[i * 4 + 2] = b0; d[i * 4 + 3] = a * 255; }
}
x.putImageData(im, 0, 0);
var ks = Object.keys(TINT); if (ks.length > 160) { delete TINT[ks[0]]; delete URL[ks[0]]; }
return (TINT[kk] = cv);
}
function idDe(id, col) { return id + "_" + String(col).replace(/[^0-9a-z]/gi, ""); }
function crear(id) {
return {
svg: function (x, y, s, c) { if (USADOS) USADOS[c] = 1; var w = CW * s, h = CH * s; return '<use href="#' + idDe(id, c) + '" x="' + x + '" y="' + (y - h * MV) + '" width="' + w + '" height="' + h * (1 + MV) + '"/>'; },
lienzo: function (ctx, X, Y, w, h, c) { ctx.drawImage(tenido(id, c), X, Y - h * MV, w, h * (1 + MV)); }
};
}
Object.keys(VAR).forEach(function (id) { T.PUNTOS[id] = crear(id); });
function simbolos(id) {
return Object.keys(USADOS || {}).map(function (c) {
var u = URL[id + c] || (URL[id + c] = tenido(id, c).toDataURL("image/png"));
return '<symbol id="' + idDe(id, c) + '" viewBox="0 0 ' + W + ' ' + TH + '" preserveAspectRatio="none"><image href="' + u + '" width="' + W + '" height="' + TH + '"/></symbol>';
}).join("");
}
var cp = T.conPunto;
T.conPunto = function (tipo, fn) {
if (!VAR[tipo]) return cp(tipo, fn);
var P = T.PUNTOS[tipo];
return function () {
var pS = T.punto, pP = T.patron, pC = T.puntada, prev = USADOS;
USADOS = {};
T.punto = function (cx, cy, col, s) { s = s || 1; return P.svg(cx * CW * s, cy * CH * s, s, col); };
T.patron = function (id, b, claro, oscuro) { return '<pattern id="' + id + '" width="' + CW + '" height="' + CH + '" patternUnits="userSpaceOnUse"><rect width="' + CW + '" height="' + CH + '" fill="' + oscuro + '"/>' + P.svg(0, 0, 1, b) + P.svg(0, CH, 1, b) + '</pattern>'; };
T.puntada = function (ctx, X, Y, w, h, col) { P.lienzo(ctx, X, Y, w, h, col); };
try {
var r = fn.apply(this, arguments);
if (typeof r === "string" && r.indexOf("<svg") === 0 && USADOS && Object.keys(USADOS).length) { var p = r.indexOf(">") + 1; r = r.slice(0, p) + "<defs>" + simbolos(tipo) + "</defs>" + r.slice(p); }
return r;
} finally { T.punto = pS; T.patron = pP; T.puntada = pC; USADOS = prev; }
};
};
if (T.PUNTADAS && !T.PUNTADAS.some(function (p) { return p[0] === "k3d"; })) T.PUNTADAS.unshift(["k3d", "Tejido 3D"], ["k3dxl", "Grueso XL"], ["k3dx", "Punto de cruz 3D"]);
})(this);
